import utils from 'utils'
import Invoice from '../../fillOpenManage/invoice1/standModel/Invoice'
import sureSendTemplate from '../../billManage/openedInvoice/view/modalSureSend.html'
import openedFullEleInvoiceChooseUkeyModal from './view/openedFullEleInvoiceChooseUkeyModal.html'
import fullEleFieldConfig from './fieldConfig'

class listCtrl {
    constructor($scope, $uibModal, logger, httpRequest, sweetalert, initSortService, exportSettingService, getOvatAmtService, $state, $filter, $timeout) {
        $scope.treeConfig = {
            isCheckall: true,
        }
        $scope.datePickerConfig = {
            autoclose: true, // 当选择一个日期之后是否立即关闭此日期时间选择器。
            minView: 'month', // 日期时间选择器所能够提供的最精确的时间选择视图。 选择日期后，不会再跳转去选择时分秒
            language: 'zh-CN', // 语言
            format: 'yyyy-mm-dd', // 格式
            forceParse: 0, // 是否强制解析输入框中的值
            pickTime: false,
            pickerPosition: 'bottom-right', // 出现的位置 默认值: 'bottom-right' (还支持 : 'bottom-left')
        }
        const types = ['is_red_all', 'is_download', 'is_list', 'send_status', 'is_print', 'invoice_source', 'yes_no_flag', 'inv_type_noe', 'is_cancel', 'out_system', 'vehicleInvStatus', 'ovat_tax_rate', 'ovat_invoice_joint', 'ovat_red_reason', 'red_blue_invoice_type', 'tax4_open_status', 'tax4_difference_tax', 'red_confirm_red_reason', 'yes_no_flag', 'specific_element', 'local_pdf_status', 'department_no', 'call_back_status']
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
            $scope.dictData.is_red_all = [
                {
                    enumTypeCode: null,
                    enumName: '蓝票',
                    enumCode: '0',
                },
                {
                    enumTypeCode: null,
                    enumName: '红票',
                    enumCode: '1',
                },
            ]
            $scope.dictData.inv_type = [
                {
                    enumCode: '61',
                    enumName: '全电电子普票',
                },
                {
                    enumCode: '62',
                    enumName: '全电电子专票',
                },
            ]
            $scope.dictData.invoice_status = [
                {
                    enumCode: '1',
                    enumName: '正常',
                },
                {
                    enumCode: '3',
                    enumName: '全部红冲',
                },
                {
                    enumCode: '4',
                    enumName: '部分红冲',
                },
            ]
            $scope.dictData.inv_type_noe = $scope.dictData.inv_type.slice(0, 2)
            $scope.dictData.inv_name_list = $scope.dictData.inv_type.reduce((total, curr) => {
                total[[curr.enumCode]] = curr.enumName
                return total
            }, {})
        })
        httpRequest.get_getUserOrgList().then((res) => {
            $scope.orgList = res.data.value
            $scope.selectedOrgs = $scope.orgList.filter((ele) => {
                if (ele.orgId === $scope.userInfo.org.orgId) {
                    ele.checked = true
                }
            })
        })
        // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
        httpRequest.get_getBelleRegion().then((res) => {
            $scope.belleRegionList = res.data.value
        })
        // 联动查询管理城市
        $scope.linkageQuery = function (enumName) {
            let departmenNoObj = $scope.dictData.department_no.find((v) => {
                if (v.enumName === enumName) {
                    return v.enumCode
                }
            })
            let belleRegionListObj = $scope.belleRegionList.find((v) => {
                if (v.regionName === enumName) {
                    return v.regionNo
                }
            })
            if (departmenNoObj) {
                $scope.departmentNo = departmenNoObj.enumCode
            }
            if (belleRegionListObj) {
                $scope.regionNo = belleRegionListObj.treeLevelCode
            }
            let params = {
                affiliation: $scope.departmentNo,
                regionNo: $scope.regionNo,
            }
            if (params.affiliation == '' || params.regionNo == '') return
            httpRequest.get_getBelleRegion(params).then((res) => {
                $scope.belleRegionCityList = res.data.value
            })
        }
        // 获取所有主管税局信息
        httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
            $scope.dictDataProvince = res.data.value
        })
        function toOutSystemdata(list, idfield, textfield) {
            const result = []
            for (let a = 0; a < list.length; a++) {
                const tempdata = {
                    enumTypeCode: null,
                    enumName: '',
                    enumCode: '',
                }
                tempdata.enumCode = list[a][idfield]
                tempdata.enumName = list[a][textfield]
                result.push(tempdata)
            }
            return result
        }
        // 对外系统
        httpRequest.post_outSystemList().then((res) => {
            $scope.dictData.out_system = toOutSystemdata(res.data.value, 'busSysId', 'busSysName')
        })
        $scope.invType = ''
        // 选中的发票
        $scope.selectedInvoices = []

        $scope.exportCollapsed = false
        $scope.exportSetting = function exportSetting() {
            exportSettingService($scope.exportID, $scope.exportConfig)
        }
        var aMonth = {}
        httpRequest.post_sysConditionConfigList({ profileType: '1', configType: '1' }).then((res) => {
            let data = res.data.value[0] ? res.data.value[0].profileInfo : ''
            const nowDate = new Date()
            let nowYears = nowDate.getFullYear()
            let nowMoths = nowDate.getMonth()
            let _nowDate = new Date(nowYears, nowMoths - 1, nowDate.getDate()) //上个月的今天
            if (data) {
                data = JSON.parse(data)
                // 0 当天往前一个月  1 当天往前至当月1号
                if (data.dateRange == '1') {
                    _nowDate = new Date(nowYears, nowMoths, 1) //本月第一天
                }
            }
            aMonth = {
                start: $filter('date')(_nowDate, 'yyyy-MM-dd'),
                end: $filter('date')(nowDate, 'yyyy-MM-dd'),
            }
            $scope.billTypeChange($scope.billTypeSet[0])
        })
        $scope.param = {
            param: {},
            pageNum: 1,
            pageSize: 10,
            orderMap: { invoiceDate: 'desc' },
        }
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {},
        }
        let stroageStr = 'openedFullEleInvoice'
        $scope.billTypeSet = [
            {
                type: '',
                label: '全部票据',
                pageConfigId: '999',
                invoiceTypeList: [],
            },
            {
                type: 1,
                label: '全电电子普票',
                pageConfigId: '61',
                invoiceTypeList: [61],
            },
            {
                type: 2,
                label: '全电电子专票',
                pageConfigId: '62',
                invoiceTypeList: [62],
            },
        ]

        $scope.reset = function () {
            $scope.param.param = {
                invoiceDateBegin: aMonth.start,
                invoiceDateEnd: aMonth.end,
                custNameCreditCode: '',
                custCreditCode: '',
                custName: '',
                applicant: '',
                waitInvoiceStatus: '',
                invoiceSource: '',
                busSysId: '',
                buySysName: '',
                diskCode: '',
                diskId: '',
                ukeyCode: '',
                ukeyId: '',
                invType: $scope.invType,
                orgIdList: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
            }
            $scope.queryParam.param.selectedOrgs = [$scope.userInfo.org]
        }
        $scope.reset()
        $scope.exportConfig = {
            version: 1.3,
            detailInfo: [
                {
                    label: '发票种类',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '全电发票号码',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票日期',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '开票人',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '发票状态',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '货物或应税劳务服务名称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '简称',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '规格型号',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单位',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '数量',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '单价',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '金额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税率',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '税额',
                    selected: true,
                    defaultWord: true,
                },
                {
                    label: '价税合计',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '零税率标识',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方名称',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方信用代码',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方地址',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方电话',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方开户行',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方银行账号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '备注',
                    selected: true,
                    defaultWord: true,
                },
            ],
            mainInfo: [
                {
                    // 0
                    label: '单据编号',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票种类',
                    selected: true,
                    default: true,
                },
                {
                    label: '发票性质',
                    selected: true,
                    default: true,
                },
                {
                    label: '全电发票号码',
                    selected: true,
                    default: true,
                },
                {
                    label: '开票日期',
                    selected: false,
                    default: false,
                },
                {
                    label: '开票人',
                    selected: false,
                    default: false,
                },
                {
                    label: '购方名称',
                    selected: true,
                    default: true,
                },
                {
                    label: '购方信用代码',
                    selected: true,
                    default: true,
                },
                {
                    label: '购方地址',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方电话',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方开户行',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '购方银行账号',
                    selected: false,
                    defaultWord: false,
                },
                {
                    label: '合计金额',
                    selected: true,
                    default: true,
                },
                {
                    label: '合计税额',
                    selected: true,
                    default: true,
                },
                {
                    label: '价税合计',
                    selected: false,
                    default: false,
                },
                {
                    label: '销方名称',
                    selected: false,
                    default: false,
                },
                {
                    label: '销方信用代码',
                    selected: false,
                    default: false,
                },
                {
                    label: '主管税局所在省市',
                    selected: false,
                    default: false,
                },
            ],
        }
        $scope.exportID = 160
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [
                {
                    text: '批量打印',
                    hasPermit: 'print_OpenedFullEleInvoice',
                    handler() {
                        $scope.surePrintBackToInvoiceBatch()
                    },
                },
                {
                    text: '发送发票',
                    hasPermit: 'send_fullOpenedInvoice',
                    handler() {
                        $scope.SendInvoiceBatchList()
                    },
                },
                {
                    text: '下载OFD',
                    hasPermit: 'allFullOpenedInvoice_download',
                    handler() {
                        $scope.downloadBackToInvoiceBatch('OFD')
                    },
                },
                {
                    text: '下载PDF',
                    hasPermit: 'allFullOpenedInvoice_download',
                    handler() {
                        $scope.downloadBackToInvoiceBatch('PDF')
                    },
                },
                {
                    text: '下载XML',
                    hasPermit: 'allFullOpenedInvoice_download',
                    handler() {
                        $scope.downloadBackToInvoiceBatch('XML')
                    },
                },
                {
                    text: '手工回调',
                    hasPermit: 'manual_callback',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        const invoiceIds = []
                        for (let i = 0; i < $scope.selectedInvoices.length; i++) {
                            invoiceIds.push($scope.selectedInvoices[i].invoiceId)
                        }
                        httpRequest.post_tax4Callback(invoiceIds).then((res) => {
                            const { success, message } = res.data
                            if (success) return logger.logSuccess(message)
                            if (!success) return logger.logError(message)
                            // let suc = 0
                            // let err = 0
                            // if (res.data.value) { //0-等待，1-成功，2-失败，-1-拒绝
                            //     for (let i = 0; i < res.data.value.length; i++) {
                            //         if (res.data.value[i].status !== '1') {
                            //             err++
                            //         } else {
                            //             suc++
                            //         }
                            //     }
                            // }
                            // logger.logSuccess('回调成功' + suc + '条，失败' + err + '条。')
                            $timeout(() => {
                                queryList()
                            }, 800)
                        })
                    },
                },
            ],
        }
        $scope.tableDropdownConfig = [
            {
                label: '详情',
                handler(item) {
                    let url
                    if (item.specificElements == '06') {
                        // 不动产租赁服务
                        url = 'outputManage.fullElectricInvoice.fullEleInvoice.realEstateDetail'
                    } else if (item.specificElements == '03') {
                        // 建筑服务
                        url = 'outputManage.fullElectricInvoice.fullEleInvoice.constructionDetail'
                    } else {
                        url = 'outputManage.fullElectricInvoice.openedFullEleInvoice.detail'
                    }
                    window.open(
                        $state.href(
                            url,
                            {
                                invoiceId: item.invoiceId,
                                invType: item.invType,
                            },
                            {
                                reload: true,
                            }
                        ),
                        '_blank'
                    )
                },
                showWhile() {
                    return true
                },
            },
            {
                label: '打印',
                handler(item) {
                    // ①当选择的发票已打印过，则提示“您选择的发票中有已经打印过的，确定要继续打印吗？”
                    if (item.isPrint === '1') {
                        sweetalert.confirm('打印确认', '你选择的发票中有已经打印过的，确定要继续打印吗？').then(() => {
                            printEleInvoice([item])
                        })
                    } else {
                        printEleInvoice([item])
                    }
                },
                showWhile(item, hasPermit) {
                    return hasPermit('print_OpenedFullEleInvoice')
                },
            },
            {
                label: '发送发票',
                handler(item) {
                    if (item.isDownload == '2') {
                        logger.logError('发票生成中，不可进行发送发票，请稍后再试')
                        return
                    }
                    $scope.SendInvoiceBatchOne(item)
                },
                showWhile(item, hasPermit) {
                    return hasPermit('send_fullOpenedInvoice') && item.isDownload != 2
                },
            },
            {
                label: '下载OFD',
                handler(item) {
                    const win = window.open(`${host.etcloudOvat}tax4/open/ordinaryElectricalOpened/downloadTax4InvoiceSingle?invoiceId=${item.invoiceId}&invoiceFileType=OFD&accessToken=${localStorage.id_token}`)
                    win.onbeforeunload = function () {
                        queryList()
                    }
                },
                showWhile(item, hasPermit) {
                    return hasPermit('fullOpenedInvoice_download')
                },
            },
            {
                label: '下载PDF',
                handler(item) {
                    const win = window.open(`${host.etcloudOvat}tax4/open/ordinaryElectricalOpened/downloadTax4InvoiceSingle?invoiceId=${item.invoiceId}&invoiceFileType=PDF&accessToken=${localStorage.id_token}`)
                    win.onbeforeunload = function () {
                        queryList()
                    }
                },
                showWhile(item, hasPermit) {
                    return hasPermit('fullOpenedInvoice_download')
                },
            },
            {
                label: '下载XML',
                handler(item) {
                    const win = window.open(`${host.etcloudOvat}tax4/open/ordinaryElectricalOpened/downloadTax4InvoiceSingle?invoiceId=${item.invoiceId}&invoiceFileType=XML&accessToken=${localStorage.id_token}`)
                    win.onbeforeunload = function () {
                        queryList()
                    }
                },
                showWhile(item, hasPermit) {
                    return hasPermit('fullOpenedInvoice_download')
                },
            },
            {
                label: '还原',
                handler(item) {
                    const { invoiceId } = item
                    httpRequest.post_batchRestore({ invoiceIds: [invoiceId] }, '还原成功，请到待处理销售单中进行处理开票。').then((res) => {})
                },
                showWhile(item, hasPermit) {
                    const { isRed, invoiceStatus, billNum, restoreStatus } = item
                    const isReduction = Object.is(isRed, '0') && Object.is(invoiceStatus, '3') && billNum > 0 && Object.is(restoreStatus, 0)
                    return hasPermit('restore_fullOpenedInvoice') && isReduction
                },
            },
            {
                label: '手工回调',
                handler(item) {
                    const { invoiceId } = item
                    httpRequest.post_tax4Callback([invoiceId]).then((res) => {
                        const { success, message } = res.data
                        if (success) return logger.logSuccess(message)
                        if (!success) return logger.logError(message)
                        // if (res.data.value[0].status === '1') { //0-等待，1-成功，2-失败，-1-拒绝
                        //     logger.logSuccess('回调成功。')
                        // } else {
                        //     logger.logError('回调失败。失败原因：' + res.data.value[0].errorMsg + '。')
                        // }
                    })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('manual_callback')
                },
            },
        ]
        $scope.billTypeChange = function billTypeChange(bill) {
            $scope.billType = bill.type
            $scope.invoiceList = []
            $scope.param.pageNum = 1
            $scope.param.orderMap = { invoiceDate: 'desc' }
            $scope.orderMap = { invoiceDate: 'desc' }
            $scope.reset()
            if (bill.type == 1) {
                stroageStr = 'openedFullEleInvoice61'
                //已开全电普票
                $scope.invType = '61'
                $scope.param.param = {
                    invoiceDateBegin: aMonth.start,
                    invoiceDateEnd: aMonth.end,
                    custCodeName: '',
                    isRed: '',
                    isDownload: '',
                    openPeople: '',
                    invoiceCode: '',
                    electricInvoiceNum: '',
                    invoiceStatus: '',
                    billBatchNo: '',
                    isList: '',
                    phone: '',
                    email: '',
                    isPrint: '',
                    invoiceSource: '',
                    invSubType: '',
                    invType: '61',
                    orgIdList: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                }
                $scope.profileType = '203'
                $scope.customizedConfig = fullEleFieldConfig[1]
            } else if (bill.type == 2) {
                stroageStr = 'openedFullEleInvoice62'
                //已开全电专票
                $scope.invType = '62'
                $scope.param.param = {
                    invoiceDateBegin: aMonth.start,
                    invoiceDateEnd: aMonth.end,
                    custCodeName: '',
                    isRed: '',
                    isDownload: '',
                    openPeople: '',
                    invoiceCode: '',
                    electricInvoiceNum: '',
                    invoiceStatus: '',
                    billBatchNo: '',
                    isList: '',
                    phone: '',
                    email: '',
                    isPrint: '',
                    invoiceSource: '',
                    invSubType: '',
                    invType: '62',
                    orgIdList: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                }
                $scope.profileType = '204'
                $scope.customizedConfig = fullEleFieldConfig[2]
            } else {
                stroageStr = 'openedFullEleInvoice'
                //全部已开全电专票
                $scope.invType = ''
                $scope.param.param = {
                    invoiceDateBegin: aMonth.start,
                    invoiceDateEnd: aMonth.end,
                    custCodeName: '',
                    isRed: '',
                    isDownload: '',
                    openPeople: '',
                    invoiceCode: '',
                    electricInvoiceNum: '',
                    invoiceStatus: '',
                    billBatchNo: '',
                    isList: '',
                    phone: '',
                    email: '',
                    isPrint: '',
                    invoiceSource: '',
                    invSubType: '',
                    invType: '',
                    orgIdList: [$scope.userInfo.org.orgId], // 机构id列表 默认当前机构
                }
                $scope.profileType = '202'
                $scope.customizedConfig = fullEleFieldConfig[3]
            }
            httpRequest.get_getUserCustomized($scope.profileType).then((res) => {
                if (res.data.value) {
                    const { orderMap } = JSON.parse(res.data.value)
                    if (orderMap) {
                        $scope.orderMap = orderMap
                    }
                }
                if ($scope.orderMap.sortKey) {
                    $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
                }
                if (!localStorage[stroageStr]) {
                    localStorage.setItem(stroageStr, JSON.stringify($scope.param))
                }
                queryList()
            })
        }
        let searchParam = localStorage[stroageStr] ? JSON.parse(localStorage[stroageStr]) : $scope.param
        for (const paramKey in searchParam.param) {
            switch (paramKey) {
                case 'invoiceDateBegin':
                    break
                case 'invoiceDateEnd':
                    break
                case 'invType':
                    break
                default:
                    if (searchParam.param[paramKey]) {
                        $scope.toggle = true
                    }
            }
        }
        // 表头排序
        $scope.orderMap = initSortService(stroageStr)
        function queryList(msg) {
            $scope.param = localStorage[stroageStr] ? JSON.parse(localStorage[stroageStr]) : $scope.param
            $scope.param.param.orgIdList = $scope.queryParam.param.selectedOrgs.map((ele) => {
                return ele.orgId
            })
            const openLoading = window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            httpRequest
                .post_findListByPage($scope.param)
                .then((res) => {
                    const result = []
                    res.data.value.list.forEach((invoice) => {
                        result.push(new Invoice(invoice))
                    })
                    $scope.invoiceList = result
                    $scope.totalItems = res.data.value.total
                    $scope.param.pageNum = res.data.value.pageNum
                    $scope.selectedInvoices = []
                })
                .finally(() => {
                    window.layer.close(openLoading)
                    if (msg) {
                        logger.logSuccess(msg)
                    }
                })
            getData()
        }
        $scope.currentOvatAmt = {}
        $scope.$watch('selectedInvoices.length', () => {
            if (!$scope.selectedInvoices.length) {
                $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal
                $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum
                $scope.totalAmt = $scope.currentOvatAmt.totalAmt
                $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt
                return
            }
            const { adValoremTotal, totalAmt, totalTaxamt } = getOvatAmtService($scope.selectedInvoices)
            $scope.adValoremTotal = adValoremTotal
            $scope.invoiceNum = $scope.selectedInvoices.length
            $scope.totalAmt = totalAmt
            $scope.totalTaxamt = totalTaxamt
        })
        function getData() {
            httpRequest.post_getTax4InvoiceStatics($scope.param.param).then((res) => {
                $scope.adValoremTotal = res.data.value.adValoremTotal.toFixed(2) || '0.00'
                $scope.invoiceNum = res.data.value.invoiceNum || 0
                $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00'
                $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00'
                $scope.currentOvatAmt = {
                    adValoremTotal: $scope.adValoremTotal,
                    invoiceNum: $scope.invoiceNum,
                    totalAmt: $scope.totalAmt,
                    totalTaxamt: $scope.totalTaxamt,
                }
            })
        }
        // 表头排序
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            localStorage.setItem(stroageStr, JSON.stringify($scope.param))
            queryList()
        }
        $scope.search = function () {
            localStorage.setItem(stroageStr, JSON.stringify($scope.param))
            queryList()
        }
        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数
        $scope.pageChanged = function () {
            // 点击页码发起查询
            localStorage.setItem(
                stroageStr,
                JSON.stringify({
                    orderMap: $scope.param.orderMap,
                    pageNum: $scope.param.pageNum,
                    pageSize: $scope.param.pageSize,
                    param: localStorage[stroageStr] ? JSON.parse(localStorage[stroageStr]).param : $scope.param.param,
                })
            )
            queryList()
        }
        // 批量打印
        $scope.surePrintBackToInvoiceBatch = function () {
            let invoiceList = $scope.selectedInvoices
            if (invoiceList.length === 0) {
                logger.logError('还未选择数据')
                return
            }
            printEleInvoice(invoiceList)
        }
        // 单张打印
        function printEleInvoice(list) {
            for (let key = 0; key < list.length; key++) {
                if (list[key].isDownload == 2) {
                    logger.logTips('暂未生成PDF文件，无法打印，请稍后再试', 'warn')
                    return
                }
            }
            const idArr = []
            list.forEach((item) => {
                idArr.push(item.invoiceId)
            })
            httpRequest
                .post_getBatchTax4PrintUrl({
                    ovatIdList: idArr,
                })
                .then((res) => {
                    const keys = res.data.value
                    $uibModal
                        .open({
                            templateUrl: 'tax4ShowPDF.html',
                            controller: [
                                '$scope',
                                '$uibModalInstance',
                                'hasPDFReader',
                                'keys',
                                function ctrl($scope, uibModalInstance, hasPDFReader, keys) {
                                    $scope.pdfSrc = `${host.etcloudOvat}tax4/open/ordinaryElectricalOpened/batchTax4InvoicePrint?storageId=${keys}&accessToken=${localStorage.id_token}`
                                    if (hasPDFReader()) {
                                        $scope.canShowPDF = true
                                    }
                                    $scope.cancel = function cancel() {
                                        uibModalInstance.close()
                                    }
                                },
                            ],
                            openedClass: 'mod-modal-haslist mod-modal mod-modal-lg modal-reimburse-invoice-detail',
                            backdrop: 'static',
                            resolve: {
                                keys() {
                                    return keys
                                },
                            },
                        })
                        .result.then(() => {
                            queryList()
                        })
                })
        }
        // 批量下载
        $scope.downloadBackToInvoiceBatch = function downloadBackToInvoiceBatch(fileType) {
            const invoiceTax4List = $scope.selectedInvoices
            if (invoiceTax4List.length === 0) {
                logger.logError('还未选择数据')
                return
            }
            for (let key = 0; key < invoiceTax4List.length; key++) {
                /*   if (invoiceTax4List[key].isDownload == 2) {
                       logger.logTips('存在文件生成中的发票，不能下载', 'warn')
                       return
                   }*/

                if (invoiceTax4List[key].ukeyManageType == 7 && fileType == 'XML') {
                    logger.logTips('存在开票点管理方式为“乐企平台”的发票，暂不支持下载XML文件，请重新筛选数据。', 'warn')
                    return
                }
            }
            let invoiceIdList = invoiceTax4List[0].invoiceId
            for (let i = 1; i < invoiceTax4List.length; i++) {
                invoiceIdList = `${invoiceIdList},${invoiceTax4List[i].invoiceId}`
            }
            let invoiceFileType = fileType
            utils.post_downLoad(
                {
                    invoiceIdList,
                    invoiceFileType,
                },
                `${host.etcloudOvat}tax4/open/ordinaryElectricalOpened/downloadTax4Invoice?accessToken=${localStorage.getItem('id_token')}`,
                queryList
            )
        }
        // 电子发票单个发送
        let prams = {}
        $scope.SendInvoiceBatchOne = function (item) {
            httpRequest.post_decryptInv(item.invoiceId).then((res) => {
                const { custMobile, custEmail } = res.data.value
                prams = {
                    phone: custMobile,
                    custEmail: custEmail,
                    phoneShow: 0,
                    sendList: [item.invoiceId],
                    isNoNo: true,
                }
                $scope.SendInvoiceBatch(prams)
            })
        }
        // 批量
        $scope.SendInvoiceBatchList = function () {
            let invoiceList = $scope.selectedInvoices
            if (invoiceList.length == 0) {
                logger.logError('还未选择数据')
                return
            }
            if (invoiceList.length > 100) {
                logger.logError('全电发票每次最多选择100张发票批量交付')
                return
            }
            const existDownload2 = invoiceList.some((x) => x.isDownload == '2')
            if (existDownload2) {
                logger.logTips('发票正处于签章排队中，暂时无法进行发票交付，请稍后再试', 'warn')
                return
            }
            if (invoiceList.length == 1) {
                $scope.SendInvoiceBatchOne(invoiceList[0])
                return
            }
            const sendList = []
            let { custEmail } = invoiceList[0]
            let { custMobile, invoiceId } = invoiceList[0]
            for (let i = 0; i < invoiceList.length; i++) {
                sendList[i] = invoiceList[i].invoiceId
                if (invoiceList[i].custEmail && invoiceList[i].custEmail != custEmail) {
                    custEmail = ''
                }
                if (invoiceList[i].custMobile && invoiceList[i].custMobile != custMobile) {
                    custMobile = ''
                }
            }
            let hasDiffBuyer = invoiceList.some((ele) => {
                return ele.custCreditCode !== invoiceList[0].custCreditCode
            })
            httpRequest.post_decryptInv(invoiceId).then((res) => {
                const { custMobile, custEmail } = res.data.value
                prams = {
                    phone: custMobile,
                    custEmail,
                    phoneShow: invoiceList.length,
                    sendList,
                    isNoNo: true,
                    hasDiffBuyer,
                }
                $scope.SendInvoiceBatch(prams)
            })
        }
        // 发送邮件
        $scope.SendInvoiceBatch = function (prams) {
            $uibModal
                .open({
                    template: sureSendTemplate,
                    controller: 'modalSureSend',
                    backdrop: 'static',
                    openedClass: ' mod-modal-RedSend mod-modal mod-modal-md',
                    resolve: {
                        items1() {
                            return prams
                        },
                    },
                })
                .result.then((prams) => {
                    // 发送邮件
                    httpRequest
                        .post_batchSendTax4Invoice(prams)
                        .then((res) => {
                            if (res.data.success) {
                                logger.logSuccess('发送成功')
                            } else {
                                logger.error('发送失败')
                            }
                        })
                        .finally(() => {
                            $timeout(() => {
                                queryList()
                            }, 800)
                        })
                })
        }

        // 导出

        $scope.exportExel = function exportExel() {
            let _url = `${host.etcloudIvatApp}tax4/ivatInvoiceEntry/exportInvoiceEntry?accessToken=${localStorage.getItem('id_token')}`
            utils.file_download(
                _url,
                $scope.queryParam.param,
                '', //type
                'POST',
                'blob',
                '',
                false
            )
        }
        $scope.exportInvoic = function () {
            let postdata = $.extend({}, $scope.param.param)
            const idArr = []
            $scope.selectedInvoices.forEach((item) => {
                idArr.push(item.invoiceId)
            })
            postdata.idList = idArr.join(',')
            let url = ''
            if ($scope.billType == '1') {
                url = `${host.etcloudOvat}tax4/open/ordinaryElectricalOpened/exportTax4InvoiceToExcel` // 全电普票
            } else if ($scope.billType == '2') {
                url = `${host.etcloudOvat}tax4/open/specialElectricalOpened/exportTax4InvoiceToExcel` // 全电专票
            } else {
                url = `${host.etcloudOvat}tax4/open/totalElectricalOpened/exportTax4InvoiceToExcel` // 全部票据
            }
            url = `${url}?accessToken=${localStorage.getItem('id_token')}`
            for (let i = 0; i < $scope.param.orderMap.length; i++) {
                postdata.sortField = `${i}:${$scope.param.orderMap[i]}`
            }
            //utils.post_downLoad(postdata, url)
            utils.file_download(
                url,
                postdata,
                '', //type
                'POST',
                'blob',
                '',
                false
            )
        }
        function chooseUkey(title, tips) {
            return $uibModal
                .open({
                    template: openedFullEleInvoiceChooseUkeyModal,
                    controller: 'openedFullEleInvoiceChooseUkeyModal',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-lg',
                    resolve: {
                        items1() {
                            return { title, tips }
                        },
                    },
                })
                .result.then(
                    (ukeyId) => {
                        return ukeyId
                    },
                    () => {
                        return ''
                    }
                )
        }
        $scope.changeUkey = async function () {
            if (!$scope.selectedInvoices.length) {
                return logger.logError('请选择数据')
            }
            let checkRows = $scope.selectedInvoices.some((ele) => {
                return !(ele.invoiceSource === 'tax4_sync' && (ele.invoiceResultDesc === '发票开票人与机构下激活失败的开票员一致，请核对开票员信息后绑定开票点。' || ele.invoiceResultDesc === '发票开票人与机构下激活成功的开票员不一致，请核对开票员信息后绑定开票点。'))
            })
            if (checkRows) {
                return logger.logError('只允许数据来源为税局下载且发票开票人与当前税号下开票员管理中的开票人不一致的数据绑定开票点。')
            }
            const invoiceIds = $scope.selectedInvoices.map((ele) => {
                return ele.invoiceId
            })

            //只允许数据来源为税局下载且发票开票人与当前税号下开票员管理中的开票人不一致的才能绑定开票点

            // logger.logError('只允许数据来源为税局下载且发票开票人与当前税号下开票员管理中的开票人不一致的数据绑定开票点')
            const ukeyId = await chooseUkey('绑定开票点', '发票上的开票人必须与所选开票点对应的开票人一致才允许绑定')
            if (!ukeyId) return
            utils.loading('请求已发送...')
            httpRequest.post_batchUpdateUkeyId({ invoiceIdList: invoiceIds, ukeyId }).then((res) => {
                utils.loaded()
                queryList(`执行${res.data.value.total}条，成功${res.data.value.success}条，失败${res.data.value.error}条`)
            })
        }
        // 查看关联销售单
        $scope.relatedBill = function relatedBill(item) {
            if (item.billNum === 0) {
                return
            }
            if (item.invoiceId === undefined) {
                return
            }
            $state.go('outputManage.fullElectricInvoice.openedFullEleInvoice.relatedBill', {
                invoiceId: item.invoiceId,
            })
        }
    }
}
listCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', 'sweetalert', 'initSortService', 'exportSettingService', 'getOvatAmtService', '$state', '$filter', '$timeout']
export default listCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/openedFullEleInvoice/list.js